var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(131,142,159,0)",
    d: "M0 0H20V20H0z",
    transform: "translate(-482 -16) translate(482 16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4f5969",
    stroke: "#4f5969",
    strokeWidth: "0.3px",
    d: "M16016 16701a7 7 0 1 1 7 7 7 7 0 0 1-7-7zm.875 0a6.125 6.125 0 1 0 6.125-6.125 6.125 6.125 0 0 0-6.125 6.125zm2.625.438a.437.437 0 0 1 .438-.437h6.125a.437.437 0 0 1 .438.438 3.5 3.5 0 0 1-7 0zm6.09.438h-5.18a2.627 2.627 0 0 0 5.18 0zm-1.277-3.062a.875.875 0 1 1 .875.875.875.875 0 0 1-.875-.876zm-4.375 0a.875.875 0 1 1 .875.875.875.875 0 0 1-.875-.876z",
    transform: "translate(-482 -16) translate(-15531 -16675)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.9b6fa298e0980683d8147224ef6389ab.svg";
export { ForwardRef as ReactComponent };